<template>
  <div id="pnc_outer" >
    <div :style="{borderColor: ( isVip ? '#cbb042' : '#fc1a34'),}">
      <ul class="note-list-group list-group" v-if="(noteList != null && noteList.length > 0)" >
        <li v-for="(item, index) in noteList" :key="'note_' + index" >
          <span v-if="item.tableId == null || item.tableId == ''">{{item.title}}</span>
          <span class="member-appli-item" v-else>
            {{item.text1 + '：'}}<a :href="'/introduce/0203/2/' + item.tableId" target="_blank" style="color: #cbb042;padding-left: 3px;padding-right: 3px;font-weight: bold;">{{item.text2}}</a>,
            <a class="item" :class="(item.tableName == 'OK') ? 'active' : ''" href="javascript:void(0);" @click="acceptMember(item)">{{item.text3}}</a>|
            <a class="item" :class="(item.tableName == 'OK') ? 'active' : ''" href="javascript:void(0);" @click="refuseMember(item)">{{item.text4}}</a>
          </span>
        </li>
      </ul>
      <div
        style="color: #999;text-align: center;min-height: 300px;width: 100%;padding-top: 130px"
        v-else>暂无通知</div>
      <bottom-paginator
        v-bind:current="page"
        v-bind:total="totalPage"
        v-on:itemClicked="paginatorClicked"
        v-bind:paginator-type="isVip ? 0 : 1"
      />
    </div>
  </div>
</template>

<script>
import BottomPaginator from "../BottomPaginator";
export default {
  name: "PersonalNotificationCenter",
  props: [

  ],
  components: {BottomPaginator},
  data() {
    return {
      title: '通知中心',
      noteList: null,
      page: 1,
      size: 10,
      isLoading: false,
      count: 0,
      firstLoad: true,
    }
  },
  computed: {
    totalPage() {
      let total = 0;
      if (this.count == 0) {
        total = 0;
      } else {
        total = Math.ceil(this.count / this.size);
      }
      return total;
    },
    user() {
      return this.$store.state.user;
    },
    isVip() {
      if (this.user == null) {
        return false;
      }
      let user = this.user;
      let memberValidDate = user.memberValidDate;
      if (memberValidDate == null) {
        return false;
      }
      return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    paginatorClicked(event) {
      let index = event.index;
      this.page = index;
      this.loadData();
    },
    loadData() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      let _this = this;
      let params = {
        pageIndex: this.page,
        size: this.size
      }
      this.$store.state.http.ajax.msgList(params,function (data) {
        _this.isLoading = false;
        let code = data.code;
        if (code == 0) {
          _this.count = data.count;

          let tempList = data.data;
          if (tempList != null && tempList.length > 0) {

            let itemList = [];
            for (let i = 0; i < tempList.length; i++) {
              let item = tempList[i];
              if (item.tableId != null && item.tableId != '') {
                let title = item.title;
                if (title != null && title != '') {

                  let patt = new RegExp("[：,|]", 'g');
                  let temp = title.split(patt);
                  if (temp.length == 4) {
                    item.text1 = temp[0];
                    item.text2 = temp[1];
                    item.text3 = temp[2];
                    item.text4 = temp[3];
                  }
                }
              }
              itemList.push(item);
            }
            _this.noteList = itemList;
            return;
          }

          _this.noteList = tempList;
        } else {

        }
        if (_this.firstLoad) {
          _this.firstLoad = false;
        }

      },function (data) {
        _this.isLoading = false;
        _this.$toast('请求你失败，请重试！');
      })
    },
    acceptMember(item) {
      //同意加入
      let teamId = this.user.id;
      let userId = item.tableId;
      let msgId = item.id;
      let params = {
        userId,
        teamId,
        msgId,
        status: 1
      }
      console.log(params);
      let _this = this;
      this.$store.state.http.ajax.ucTeamsOp(params, function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.$toast('您已同意成员加入您的团体！');
          _this.loadData();
          return;
        }
        _this.$toast('操作失败！');
      }, function (data) {
        _this.$toast('操作失败，请重试！');
      })

    },
    refuseMember(item) {
      // 拒绝加入
      let teamId = this.user.id;
      let userId = item.tableId;
      let msgId = item.id;
      let params = {
        userId,
        teamId,
        msgId,
        status: 2
      }
      let _this = this;
      this.$store.state.http.ajax.ucTeamsOp(params, function (data) {
        console.log(data);
        let code = data.code;
        if (code == 0) {
          _this.$toast('您已拒绝成员加入您的团体！');
          _this.loadData();
          return;
        }

        _this.$toast('操作失败！');
      }, function (data) {
        _this.$toast('操作失败，请重试！');
      })
    },
  }
}
</script>

<style scoped>


  #pnc_outer {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
  }

  #pnc_outer > div {
    border: solid 1px #cbb042;
    width: 100%;
    min-width: 300px;
    /*max-width: 1000px;*/
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 0px;
    padding-left: 15px;
    padding-right: 15px;
  }

  .note-list-group {
    text-decoration: none;
    width: 100%;
    min-height: 400px;

    /*background-color: yellow;*/
  }
  .note-list-group li {
    list-style-type: none;
    padding: 10px 0;
    border-bottom: solid 1px #eee;
    color: #333;
    font-size: 1rem;
    margin: auto;
  }

  .member-appli-item a {
    text-decoration: none;
  }


  .member-appli-item > a:hover {

  }

  .member-appli-item .item {
    color: #fc1a34;
    padding-left: 3px;
    padding-right: 3px;
  }

  .member-appli-item .item:hover {
    color: #cbb042;
  }

  .member-appli-item a.active {
    color: #999;
    pointer-events: none;
  }


</style>



// WEBPACK FOOTER //
// src/components/personal/PersonalNotificationCenter.vue